import React, { useState } from 'react';

import CpoCdrsPanel from './CpoCdrsPanel';
import CpoLocationsPanel from './CpoLocationsPanel';
import CpoSessionsPanel from './CpoSessionsPanel';
import CpoTariffsPanel from './CpoTariffsPanel';

/**
 * CpoRoleOperations component for managing CPO-specific actions.
 * @param {any} props The props.
 * @param {any} props.countryCode The country code.
 * @param {any} props.partyId The party ID.
 */
export default function CpoRoleOperations({
  countryCode,
  partyId,
}: Readonly<{
  countryCode: string;
  partyId: string;
}>) {
  const [activeModule, setActiveModule] = useState('Locations');

  const modules = [
    { name: 'Locations', eligible: '1/1' },
    { name: 'Tariffs', eligible: '1/1' },
    { name: 'Sessions', eligible: '1/1' },
    { name: 'Cdrs', eligible: '1/1' },
  ];

  /**
   * Renders the active module panel.
   */
  const renderActiveModule = () => {
    switch (activeModule) {
      case 'Locations':
        return <CpoLocationsPanel countryCode={countryCode} partyId={partyId} />;
      case 'Tariffs':
        return <CpoTariffsPanel countryCode={countryCode} partyId={partyId} />;
      case 'Sessions':
        return <CpoSessionsPanel countryCode={countryCode} partyId={partyId} />;
      case 'Cdrs':
        return <CpoCdrsPanel countryCode={countryCode} partyId={partyId} />;
      default:
        return (
          <div className="cpo-module-placeholder">
            <p>
              Module &quot;{activeModule}&quot; operations are currently under construction.
            </p>
          </div>
        );
    }
  };

  return (
    <>
      {/* ── Role Detail Card ─────────────────────────────────────────── */}
      <div className="operations-role-card">
        <div className="role-card-header">
          <div>
            <h3>CPO Role Operations</h3>
            <p>
              Country: {countryCode} | Party: {partyId}
            </p>
          </div>
          <div className="role-badges-right">
            <span className="badge badge-primary">CPO</span>
            <span className="badge badge-gray">
              {countryCode}/{partyId}
            </span>
            <span className="badge badge-gray">Owned Modules: 4</span>
            <span className="badge badge-success">Connections: 1</span>
          </div>
        </div>

        <div className="modules-selection">
          <h4>Owned Modules</h4>
          <p className="subtitle">Choose one workspace to operate on.</p>
          <div className="modules-cards-row">
            {modules.map((module_) => (
              <div
                key={module_.name}
                className={`module-card ${activeModule === module_.name ? 'active' : ''}`}
                onClick={() => setActiveModule(module_.name)}
                role="button"
                tabIndex={0}
                onKeyDown={(event) => {
                  if (event.key === 'Enter' || event.key === ' ') {
                    setActiveModule(module_.name);
                  }
                }}>
                <h5>{module_.name}</h5>
                <span>{module_.name}</span>
                <p>Eligible: {module_.eligible}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="cpo-active-module-wrapper">{renderActiveModule()}</div>
    </>
  );
}
